var map = {
	"./Drone.png": "f031",
	"./Tu4yrA4JFn-cropped.gif": "1732",
	"./coral-data.png": "6bb9",
	"./drBAop7Hdn-cropped.gif": "f611",
	"./swipetable-grayscale.gif": "0531"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";